import { TextButtonLink } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from '../../common/typography';
import { buildContactInfoUrl, buildPrivacyTermsUrl, buildUserTermsUrl } from '../../locale/utils';

const FooterDiv = styled.div`
  background-color: ${({ theme: { cbThemeMode = 'light' } }) => {
    return cbThemeMode === 'light' ? 'rgba(255 255 255 / 60%)' : 'rgba(20 20 20 / 60%)';
  }};
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  padding-block-end: 12px;
`;

const DesktopFooter = styled(FooterDiv)<{ sticky: boolean }>`
  height: 48px;
  gap: 10px;
  flex-direction: row;
  padding: 12px 32px;
  ${({ sticky }) =>
    sticky
      ? `
      position: fixed;
      bottom: 0;
      left: 0;
    `
      : ''}
`;

const MobileFooter = styled(FooterDiv)<{ sticky: boolean }>`
  height: 56px;
  gap: 16px;
  flex-direction: column;
  padding: 0 16px;
`;

type ComplianceFooterProps = {
  isMobile: boolean;
  locale?: string;
  country?: string;
  showContactUs?: boolean;
  showUserTerms?: boolean;
  showPrivacyPolicy?: boolean;
  sticky?: boolean;
};

const ComplianceFooter = ({
  isMobile,
  locale,
  country,
  showContactUs = false,
  showUserTerms = false,
  showPrivacyPolicy = false,
  sticky = false,
}: ComplianceFooterProps) => {
  const FooterComponent = isMobile ? MobileFooter : DesktopFooter;
  return (
    <FooterComponent sticky={sticky}>
      <T.Tiny>© Wolt 2014-{new Date().getFullYear()}</T.Tiny>
      <LinkContainer>
        {showContactUs && (
          <TextButtonLink
            variant="neutral"
            size="small"
            href={buildContactInfoUrl(locale, country)}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="experience.contact-us" />
          </TextButtonLink>
        )}
        {showUserTerms && (
          <TextButtonLink
            variant="neutral"
            size="small"
            href={buildUserTermsUrl(locale, country)}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="experience.terms" />
          </TextButtonLink>
        )}
        {showPrivacyPolicy && (
          <TextButtonLink
            variant="neutral"
            size="small"
            href={buildPrivacyTermsUrl(locale, country)}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="experience.privacy" />
          </TextButtonLink>
        )}
      </LinkContainer>
    </FooterComponent>
  );
};

export default ComplianceFooter;
